module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel-suns_access_02-7de6651d978365384dc666c70bc00957.jpg";